import React from "react";
import { Card, Row, Col, Button, Typography, Space } from "antd";
import Meta from "../Meta";
import metaData from "../../data/metaData";
import Number from "../General/Number";
import log from "../../utils/log";
import VoucherTable from "../Welcome/VoucherTable";

const { Text, Title } = Typography;

const PackList = ({ state = {}, canEdit, onDelete, onAdd, onEditVoucher, onPackQtyChange }) => {
  const { data = [] } = state; // `onChange` is used to propagate changes to the parent

  return (
    <Space direction="vertical" style={{ width: "100%" }}>
      {data.map((pack, index) => (
        <Card
          key={index}
          style={{
            border: "1px solid var(--ion-color-step-100)",
            borderRadius: "8px",
            boxShadow: "0px 2px 8px rgba(0, 0, 0, 0.1)",
          }}
        >
          <Row align="middle">
            {/* Left: Pack Number */}
            <Col span={4}>
              <Title level={4} style={{ margin: 0 }}>{`Pack #${index + 1}`}</Title>
            </Col>

            {/* Right: Editable Quota and Action Buttons */}
            <Col span={20}>
              <Row justify="space-between" align="middle">
                {/* Editable Quota */}
                <Col>
                  <Number
                    min={1}
                    prefix={
                      <Text strong style={{ marginRight: "1rem" }}>
                        Quota:
                      </Text>
                    }
                    variant="filled"
                    value={pack.qty || 0}
                    onChange={(value) => onPackQtyChange(pack.id, value)} // Pass pack ID and new quota value to parent
                    style={{width: "7.5rem"}}
                  />
                </Col>

                {/* Action Buttons */}
                <Col>
                  <Button
                    variant="outlined"
                    color="danger"
                    style={{ marginRight: "2rem" }}
                    onClick={() => onDelete(pack.id)}
                  >
                    Remove Pack
                  </Button>
                  <Button type="primary" disabled={!canEdit} onClick={() => onAdd(pack.id)}>
                    Add Voucher
                  </Button>
                </Col>
              </Row>
            </Col>
          </Row>

          <VoucherTable
            data={pack?.products || []}
            canEdit={canEdit}
            loading={false}
            onEdit={(productId) => {onEditVoucher(pack.id, productId);}}
          />
        </Card>
      ))}
    </Space>
  );
};

export default PackList;
